/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenarios_TitleInputs */

const en_pol_scenarios_title = /** @type {(inputs: Pol_Scenarios_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Five ways of use`)
};

const id_pol_scenarios_title = /** @type {(inputs: Pol_Scenarios_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lima cara pakai`)
};

/**
* | output |
* | --- |
* | "Five ways of use" |
*
* @param {Pol_Scenarios_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenarios_title = /** @type {((inputs?: Pol_Scenarios_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenarios_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenarios_title(inputs)
	return en_pol_scenarios_title(inputs)
});